module.exports = {"231282001":"朝阳区","231282002":"东升区","231282003":"西园区","231282004":"正阳区","231282100":"肇东镇","231282101":"昌五镇","231282102":"宋站镇","231282103":"五站镇","231282104":"尚家镇","231282105":"姜家镇","231282106":"里木店镇","231282107":"四站镇","231282108":"涝洲镇","231282109":"五里明镇","231282110":"黎明镇","231282111":"西八里镇","231282201":"太平乡","231282203":"海城乡","231282204":"向阳乡","231282205":"洪河乡","231282206":"跃进乡","231282212":"德昌乡","231282213":"宣化乡","231282214":"安民乡","231282215":"明久乡","231282500":"四方山农场","231282501":"涝洲鱼种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231282.json
// module id = 799
// module chunks = 0